// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pay_box{
    width: 350px;
    /* height: 234px; */
    flex-shrink: 0;
    background: linear-gradient(0deg, #100027, #100027),linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),
linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05));
    border-radius:16px;
}
.pay_title{
    color: var(--White, #FFF);
    text-align: center;
    font-family: Urbanist;
    margin:10px 0px;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 1px;
}
.pay_desc{
    color: var(--White, #FFF);
    text-align: center;
    font-family: Urbanist;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 1px;
}



.card_details_btn{
    border-radius: 10px;
    background: #06EFC5;
    box-shadow: 0px 2px 24px 0px rgba(16, 155, 255, 0.24);
    width:50%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 56px;
    color:black;
    cursor: pointer;
}
.card_details_text{
    color: #100027;
    text-align: center;
    font-family: Open Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.165px;
}

.outer_container{
background: rgba(24, 0, 57, 0.75);
backdrop-filter: blur(0.5px); 
}

.btn_pay_continue{
    border-radius: 10px;
    border: 1px solid #06EFC5;
    background: linear-gradient(89deg, #242424 -261.85%, rgba(36, 36, 36, 0.00) 98.43%);
    width:50%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 56px;
    color:black;
    cursor: pointer;
}

.continue_text{
    color:white;
    text-align: center;
    font-family: Open Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.165px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Home/paymentProcedure.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd;2EACuE;IACvE,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;;;AAIA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,qDAAqD;IACrD,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;AACA,iCAAiC;AACjC,4BAA4B;AAC5B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mFAAmF;IACnF,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;AAC5B","sourcesContent":[".pay_box{\n    width: 350px;\n    /* height: 234px; */\n    flex-shrink: 0;\n    background: linear-gradient(0deg, #100027, #100027),linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),\nlinear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05));\n    border-radius:16px;\n}\n.pay_title{\n    color: var(--White, #FFF);\n    text-align: center;\n    font-family: Urbanist;\n    margin:10px 0px;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 1px;\n}\n.pay_desc{\n    color: var(--White, #FFF);\n    text-align: center;\n    font-family: Urbanist;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    letter-spacing: 1px;\n}\n\n\n\n.card_details_btn{\n    border-radius: 10px;\n    background: #06EFC5;\n    box-shadow: 0px 2px 24px 0px rgba(16, 155, 255, 0.24);\n    width:50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 56px;\n    color:black;\n    cursor: pointer;\n}\n.card_details_text{\n    color: #100027;\n    text-align: center;\n    font-family: Open Sans;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: -0.165px;\n}\n\n.outer_container{\nbackground: rgba(24, 0, 57, 0.75);\nbackdrop-filter: blur(0.5px); \n}\n\n.btn_pay_continue{\n    border-radius: 10px;\n    border: 1px solid #06EFC5;\n    background: linear-gradient(89deg, #242424 -261.85%, rgba(36, 36, 36, 0.00) 98.43%);\n    width:50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 56px;\n    color:black;\n    cursor: pointer;\n}\n\n.continue_text{\n    color:white;\n    text-align: center;\n    font-family: Open Sans;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: -0.165px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
